export default __webpack_public_path__ + "static/media/invite_icon.ff7fb3b2.svg";